import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import TextInput from "../TextInput";
import Field from "./Field";

export default {
    title: "Form components/Field",
    component: Field
} as ComponentMeta<typeof Field>;

type Story = GenericStory<Partial<React.ComponentProps<typeof Field>>>;

export const Default: Story = args => (
    <div style={{ width: "360px" }}>
        <Field label="Leading label" {...args}>
            <TextInput value="Text" placeholder="Placeholder" />
        </Field>
    </div>
);

export const WithError: Story = args => (
    <Field
        error={
            <>
                Available quantity of Product 1 at BER2: <strong>2000</strong>
            </>
        }
        helperText="Helper text should not appear"
        label="Total quantity of product requested"
        {...args}
    >
        <TextInput value="2500" />
    </Field>
);

export const WithErrorAsString: Story = args => (
    <Field
        error="Available quantity of Product 1 at BER2: 2000"
        helperText="Helper text should not appear"
        label="Total quantity of product requested"
        {...args}
    >
        <TextInput value="2500" />
    </Field>
);

export const WithLink: Story = args => (
    <Field
        helperText={
            <>
                Video link not present?{" "}
                <a href="packages/design-system/src/components/form/Field#/">Upload reference images</a>
            </>
        }
        label="Link to Video"
        {...args}
    >
        <TextInput value="www.googledrive/xyz.com" />
    </Field>
);

export const WithBoldText: Story = args => (
    <Field
        helperText={
            <>
                Available quantity of Product 1 at BER2: <strong>3000</strong>
            </>
        }
        label="Total quantity of product requested"
        {...args}
    >
        <TextInput disabled value="2500" />
    </Field>
);

export const WithTooltip: Story = args => (
    <Field label="Total quantity of product requested" tooltip="This is a tooltip" {...args}>
        <TextInput value="2500" />
    </Field>
);
